<template>
  <div>
    <inline-message severity="info" :closable="false">
      {{ t('Configurações do sistema para esta franquia') }}
    </inline-message>

    <configurations-table
      ref="configurationsTableRef"
      :franquia-id="franquiaId"
      @edit-config="handleEditConfig">
    </configurations-table>

    <!-- ConfigurationModal is centralized in ModalManager.vue - opened via eventBus -->
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { log } from '../../utils/DebugLogger';
import ConfigurationsTable from './ConfigurationsTable.vue';
// ConfigurationModal is centralized in ModalManager.vue - opened via eventBus
import { eventBus } from '../../eventBus';

type Id = number | string;

interface ConfigurationsTableInstance {
  loadData: () => void;
}

interface Props {
  franquiaId: number;
}

const props = defineProps<Props>();

const { t } = useI18n();

// Refs
const configurationsTableRef = ref<ConfigurationsTableInstance | null>(null);

// Methods
const handleEditConfig = (configNome: Id): void => {
  log('FranquiasConfigTab', 'handleEditConfig', 'Opening edit modal via eventBus', configNome);
  eventBus.emit('modal.configuration.open', {
    configNome: configNome,
    franquiaId: props.franquiaId,
  });
};

// Watch for franquiaId changes
watch(() => props.franquiaId, (newId) => {
  log('FranquiasConfigTab', 'watch franquiaId', 'Franchise ID changed', newId);

  // Reload table when franchise changes
  if (configurationsTableRef.value) {
    configurationsTableRef.value.loadData();
  }
});
</script>

<style scoped>
/* PrimeVue Message component handles styling */
</style>
